<div class="agenx-modal">
  <header class="agenx-modal__header">
    <h4 class="agenx-modal__h4">Asignar operario</h4>
    <img (click)="closeModal()" class="agenx-modal__img" [src]="icon_x_src" alt="Close">
  </header>

  <div class="agenx-modal__container body-width">
    <section class="content-width scroll-80vh">
        <div class="grid-section">
          <section class="grid-operators">
            <span class="">Conductores</span>
            @for (driver of driversList; track $index) {
              <agenx-radio [control]="driverCtrl" [idInput]="'driver-'+ driver.id" [value]="driver.id.toString()" [checked]="false"
                [nameInput]="'driver'" [label]="driver.name" [type]="noSelected ? 'error' : 'info'"
                class="agenx-alert-radio__radio"></agenx-radio>
            }
          </section>
          <section class="grid-operators">
            <span class="text-blue third-font font-size-13 reset-margin-padding">Auxiliares</span>
            @for (aux of auxList; track $index) {
              <agenx-checkbox [idInput]="'aux-'+ aux.id" [value]="aux.id.toString()" [checked]="false"
                [nameInput]="'aux'" [label]="aux.name" [type]="noSelected ? 'error' : 'info'"
                class="agenx-alert-radio__radio"></agenx-checkbox>
            }
          </section>
        </div>

        <ng-template #no_vehicles>
          <div class="card-simple alert-simple px-0 m-0 w-100">
            <div class="card-simple__body alert-body alert-basic-info m-0">
              <div class="alert-img"></div>
              <a class="">
                <p> No existen operarios.</p>
              </a>
            </div>
          </div>
        </ng-template>

        <div style="justify-self: end; margin-top: 1rem;">
          <agenx-button (click)="save()" [typeButton]="'green'" [buttonText]="'Guardar'" class="middle"
            [loadingButton]="loading"></agenx-button>
        </div>

      </section>


  </div>

</div>
